// client/finalize-pdf.ts
import { logger } from "@adornis/base/logging.js";
import { DONE_LOADING_CONSTANT } from "../done-loading-constant.js";
function finalizePDF() {
  document.dispatchEvent(new CustomEvent(DONE_LOADING_CONSTANT, { bubbles: true, composed: true }));
  window[DONE_LOADING_CONSTANT] = true;
  logger.info("PDF done, sent finalizing event");
}
export {
  finalizePDF
};
